import React from 'react';
import { Link } from 'react-router-dom';
import { MessageSquare, ArrowLeft } from 'lucide-react';

const PrivacyPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <nav className="border-b border-gray-200 bg-white/80 backdrop-blur-md sticky top-0 z-40">
        <div className="max-w-4xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2 hover:opacity-80 transition-opacity">
            <MessageSquare className="w-6 h-6 text-indigo-600" />
            <span className="text-lg font-bold text-gray-950">ACBotHub</span>
          </Link>
          <Link to="/" className="flex items-center gap-1.5 text-sm text-gray-500 hover:text-gray-700">
            <ArrowLeft className="w-4 h-4" />Volver
          </Link>
        </div>
      </nav>

      <main className="max-w-4xl mx-auto px-6 py-12 prose prose-gray max-w-none" data-testid="privacy-content">
        <h1 className="text-3xl font-bold text-gray-950 mb-2">Politica de Privacidad de ACBotHub</h1>
        <p className="text-sm text-gray-500 mb-8"><strong>Ultima actualizacion:</strong> 15 de abril de 2026</p>

        <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-3">1. Introduccion</h2>
        <p className="text-gray-700 leading-relaxed">ACBotHub se compromete a proteger la privacidad de sus usuarios. Esta Politica describe como recopilamos, usamos y protegemos tu informacion personal.</p>

        <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-3">2. Informacion que Recopilamos</h2>
        <p className="text-gray-700 leading-relaxed font-semibold">2.1. Informacion que nos proporcionas directamente:</p>
        <ul className="text-gray-700 space-y-1.5 ml-4">
          <li>Nombre completo</li>
          <li>Correo electronico</li>
          <li>Nombre de tu negocio</li>
          <li>Informacion de pago (procesada por PayPal, no almacenamos datos de tarjetas)</li>
          <li>Configuracion de tu asistente virtual (nombre, prompt, horarios, servicios)</li>
          <li>API Key de OpenAI (almacenada de forma encriptada)</li>
        </ul>
        <p className="text-gray-700 leading-relaxed font-semibold mt-4">2.2. Informacion recopilada automaticamente:</p>
        <ul className="text-gray-700 space-y-1.5 ml-4">
          <li>Direccion IP</li>
          <li>Tipo de navegador y dispositivo</li>
          <li>Paginas visitadas dentro de la Plataforma</li>
          <li>Fecha y hora de acceso</li>
          <li>Registros de actividad del asistente virtual</li>
        </ul>

        <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-3">3. Como Usamos tu Informacion</h2>
        <p className="text-gray-700 leading-relaxed">Utilizamos tu informacion para:</p>
        <ul className="text-gray-700 space-y-1.5 ml-4">
          <li>Crear y gestionar tu cuenta</li>
          <li>Procesar pagos y suscripciones</li>
          <li>Operar y mejorar el servicio</li>
          <li>Enviarte comunicaciones relacionadas con tu cuenta (verificacion de email, facturas, notificaciones de servicio)</li>
          <li>Responder a tus consultas de soporte</li>
          <li>Cumplir con obligaciones legales</li>
        </ul>

        <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-3">4. Almacenamiento y Seguridad</h2>
        <p className="text-gray-700 leading-relaxed">4.1. Tu informacion se almacena en servidores seguros a traves de MongoDB Atlas, con medidas de seguridad que incluyen encriptacion en transito y en reposo.</p>
        <p className="text-gray-700 leading-relaxed">4.2. Las API Keys se almacenan encriptadas usando estandares de cifrado modernos.</p>
        <p className="text-gray-700 leading-relaxed">4.3. Implementamos medidas tecnicas y organizativas para proteger tu informacion contra acceso no autorizado, perdida o alteracion.</p>
        <p className="text-gray-700 leading-relaxed">4.4. A pesar de nuestros esfuerzos, ningun sistema es completamente seguro. En caso de una brecha de seguridad que afecte tus datos, te notificaremos en un plazo maximo de 72 horas.</p>

        <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-3">5. Comparticion de Datos con Terceros</h2>
        <p className="text-gray-700 leading-relaxed">ACBotHub no vende ni arrienda tu informacion personal a terceros. Solo compartimos datos con:</p>
        <ul className="text-gray-700 space-y-1.5 ml-4">
          <li><strong>PayPal:</strong> Para procesar pagos. Consulta la politica de privacidad de PayPal en paypal.com.</li>
          <li><strong>OpenAI:</strong> Las conversaciones de tu asistente se procesan a traves de la API de OpenAI segun los terminos de ese proveedor.</li>
          <li><strong>Resend:</strong> Para el envio de correos electronicos transaccionales.</li>
          <li><strong>Render:</strong> Proveedor de infraestructura donde se aloja el servicio.</li>
          <li><strong>Autoridades competentes:</strong> Cuando sea requerido por ley.</li>
        </ul>

        <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-3">6. Conversaciones del Asistente Virtual</h2>
        <p className="text-gray-700 leading-relaxed">6.1. Las conversaciones que tus clientes tengan con tu asistente virtual se procesan a traves de la API de OpenAI bajo tu API Key.</p>
        <p className="text-gray-700 leading-relaxed">6.2. ACBotHub no almacena el contenido completo de las conversaciones de forma permanente, solo registros tecnicos necesarios para el funcionamiento del servicio.</p>
        <p className="text-gray-700 leading-relaxed">6.3. Eres responsable de informar a tus propios clientes que estan interactuando con un asistente virtual con inteligencia artificial.</p>

        <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-3">7. Tus Derechos</h2>
        <p className="text-gray-700 leading-relaxed">De acuerdo con la Ley N 19.628 sobre Proteccion de la Vida Privada de Chile, tienes derecho a:</p>
        <ul className="text-gray-700 space-y-1.5 ml-4">
          <li><strong>Acceder</strong> a los datos personales que tenemos sobre ti</li>
          <li><strong>Rectificar</strong> datos inexactos o incompletos</li>
          <li><strong>Eliminar</strong> tu cuenta y datos personales</li>
          <li><strong>Oponerte</strong> al tratamiento de tus datos</li>
        </ul>
        <p className="text-gray-700 leading-relaxed mt-2">Para ejercer estos derechos, escribenos a <strong>soporte@acbothub.com</strong>.</p>

        <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-3">8. Retencion de Datos</h2>
        <p className="text-gray-700 leading-relaxed">Conservamos tu informacion mientras mantengas una cuenta activa en ACBotHub. Al eliminar tu cuenta, borraremos tus datos personales en un plazo maximo de 30 dias, excepto aquellos que debamos conservar por obligaciones legales o contables.</p>

        <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-3">9. Cookies</h2>
        <p className="text-gray-700 leading-relaxed">ACBotHub utiliza cookies tecnicas necesarias para el funcionamiento de la Plataforma, como mantener tu sesion iniciada. No utilizamos cookies de rastreo publicitario de terceros.</p>

        <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-3">10. Menores de Edad</h2>
        <p className="text-gray-700 leading-relaxed">ACBotHub no esta dirigido a menores de 18 anos. No recopilamos conscientemente informacion de menores. Si detectamos que un menor ha creado una cuenta, la eliminaremos de inmediato.</p>

        <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-3">11. Cambios en esta Politica</h2>
        <p className="text-gray-700 leading-relaxed">Podemos actualizar esta Politica periodicamente. Te notificaremos por correo electronico ante cambios significativos. La fecha de "ultima actualizacion" al inicio del documento indicara cuando fue modificada por ultima vez.</p>

        <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-3">12. Contacto</h2>
        <p className="text-gray-700 leading-relaxed">Para consultas sobre esta Politica de Privacidad: <strong>soporte@acbothub.com</strong></p>
        <p className="text-gray-700 leading-relaxed">acbothub.com</p>
      </main>
    </div>
  );
};

export default PrivacyPage;
